import { call } from "redux-saga/effects";

let getInfoModule = null;
export function* getInfoCerberus() {
  if (!getInfoModule) {
    getInfoModule = yield call(() => import('./get-info'));
  }
  //llamada a modulo
  yield call(getInfoModule.getInfo)
}

let getSummaryInfoModule = null;
export function* getSummaryInfoCerberus({ data }) {
  if (!getSummaryInfoModule) {
    getSummaryInfoModule = yield call(() => import('./get-summary-info'));
  }
  //llamada a modulo
  yield call(getSummaryInfoModule.getSummaryInfo, { data })
}

let getSummaryInfoWithDateModule = null;
export function* getSummaryInfoCerberusWithDate() {
  if (!getSummaryInfoWithDateModule) {
    getSummaryInfoWithDateModule = yield call(() => import('./get-summary-info-with-date'));
  }
  //llamada a modulo
  yield call(getSummaryInfoWithDateModule.getSummaryInfo)
}

let phoneCallsIdentifierSwitchStateModule = null;
export function* phoneCallsIdentifierSwitchState({ targetActiveState }) {
  if (!phoneCallsIdentifierSwitchStateModule) {
    phoneCallsIdentifierSwitchStateModule = yield call(() => import('./phone-calls-identifier-switch-state'));
  }
  //llamada a modulo
  yield call(phoneCallsIdentifierSwitchStateModule.phoneCallsIdentifierSwitchState, { targetActiveState })
}

let spamCallsBlockingSwitchStateModule = null;
export function* spamCallsBlockingSwitchState({ targetActiveState }) {
  if (!spamCallsBlockingSwitchStateModule) {
    spamCallsBlockingSwitchStateModule = yield call(() => import('./spam-calls-blocking-switch-state'));
  }
  //llamada a modulo
  yield call(spamCallsBlockingSwitchStateModule.spamCallsBlockingSwitchState, { targetActiveState })
}

let fraudulentSMSBlockingSwitchStateModule = null;
export function* fraudulentSMSBlockingSwitchState({ targetActiveState }) {
  if (!fraudulentSMSBlockingSwitchStateModule) {
    fraudulentSMSBlockingSwitchStateModule = yield call(() => import('./fraudulent-sms-blocking-switch-state'));
  }
  //llamada a modulo
  yield call(fraudulentSMSBlockingSwitchStateModule.fraudulentSMSBlockingSwitchState, { targetActiveState })
}
